import { useQueryDetails } from '@gogame/query';

import { loadApiIntegrationDetails } from 'scenes/ApiIntegrations/sources/apiIntegrations';

import { details } from './queryKeyFactory';

export const useLoadPartnerApiDetails = ({ id }) => {
  return useQueryDetails(
    details(id),
    () => loadApiIntegrationDetails({ id }),
    {}
  );
};
